const ivrcalltransfer = (state = [], action) => {
    switch (action.type) {
      case 'IVR':
      return {
          type: "IVR",
          transfers: action.transfers
        }
      default:
        return state
    }
  }
  
  export default ivrcalltransfer